ALLOWED_CONTROLLER = 'door_sentries'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  doorSentriesTable = $('#door_sentries').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#door_sentries').data('source')
    order: [ [ 0, "asc" ] ]
    aoColumnDefs:
      [ { 'bSortable': false, 'aTargets': [ 3, 4, 5, 6, 7, 8, 9 ] } ]

  selectAllButton()
  updateFirmwaresListener(doorSentriesTable)

$(document).ready(ready)

selectAllButton = ->
  $('*[data-selector="select_all_door_sentries"]').on 'click', (e) ->
    unless $('[data-selector="select_all_door_sentries"]').prop('checked')
      $('input[data-selector="door_sentry_checkbox"]').prop('checked', false)
    else
      $('input[data-selector="door_sentry_checkbox"]').prop('checked', true)
